<template>
  <VContainer class="your-documents-page">
    <VRow v-if="isLoading">
      <VCol cols="12">
        <div class="d-flex flex-column align-center justify-center py-4 w-100">
          <VProgressCircular indeterminate color="primary" />
        </div>
      </VCol>
    </VRow>
    <VRow v-else>
      <VCol cols="12">
        <Card class="w-100">
          <div class="documents">
            <template v-if="documents.length">
              <div
                class="documents__item"
                v-for="file in documents"
                :key="file.documentId"
                @click="handleViewDocument(file)"
              >
                <div class="d-flex gap-16">
                  <VIcon icon="mdi-file-document-multiple" size="large"></VIcon>
                  <div class="documents__item__title">{{ file.documentTitle }}</div>
                </div>

                <div class="documents__item__date">{{ file.createdDate }}</div>
              </div>
            </template>
            <div v-else class="d-flex gap-10 my-3">
              <VIcon icon="mdi-information-slab-circle-outline" size="24" color="primary"></VIcon>
              <span>Documents not found!</span>
            </div>
          </div>
        </Card>
      </VCol>
    </VRow>
  </VContainer>
  <ViewDocumentModal v-model="isShowViewDocumentModal" :documentId="documentId" />
</template>
<script>
import { mapActions, mapGetters } from 'vuex';
// Components
import Card from '@/components/common/Card/Card.vue';
import ViewDocumentModal from '@/components/modals/ViewDocumentModal/ViewDocumentModal.vue';
// Service
import documentsService from '@/services/documents-service/documents.service';
// Utils
import { formatDocuments } from '@/utils/formatData';
export default {
  name: 'YourDocumentsPage',
  components: { Card, ViewDocumentModal },
  computed: {
    ...mapGetters('user', ['userId'])
  },
  data() {
    return {
      isLoading: true,
      documents: [],
      isShowViewDocumentModal: false,
      documentId: null
    };
  },
  mounted() {
    this.getDocuments();
  },
  methods: {
    ...mapActions('main', ['showSnackbar']),
    async getDocuments() {
      this.isLoading = true;
      try {
        const { documents } = await documentsService.getDocuments({ recordId: this.userId });
        this.documents = formatDocuments(documents ?? []);
      } catch (err) {
        console.error(err);
        this.showSnackbar({ text: err?.message || 'Oops, Something Went Wrong', color: 'red' });
      } finally {
        this.isLoading = false;
      }
    },
    // View Document
    handleViewDocument(item) {
      if (!item?.documentId) {
        return;
      }
      this.isShowViewDocumentModal = true;
      this.documentId = item.documentId;
    }
  }
};
</script>
